// @flow
import FeatureContext from './FeatureContext';

const FeatureConsumer = FeatureContext.Consumer;

export default FeatureConsumer;
